import React from 'react';
import { ZCDTable } from '@zencity/common-ui';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

/**
 * For display the data table of the map layer counts without the sentiment breakdown
 */
const MapLayerDataTable = (props) => {
  const { restrictPinsInPolygons, counts } = props;
  const { t } = useTranslation();
  const columns = [
    { Header: 'Boundary', accessor: 'label' },
    { Header: 'Count', accessor: 'count' },
    { Header: '%', accessor: 'percentage' },
  ];
  const total = counts.reduce((acc, count) => acc + count.subtotal, 0);
  const data = counts.reduce((acc, count) => {
    if (restrictPinsInPolygons && count.mapLayerId === '0') return acc;

    acc.push({
      label: count.mapLayerId === '0' ? t('pinDrop.outsideBoundaries') : count.label,
      count: count.subtotal,
      percentage: ((count.subtotal / total) * 100).toFixed(2),
    });

    return acc;
  }, []);

  if (data.length <= 1) return null;

  return (
    <div className="map-layer-data-tables">
      <ZCDTable columnArray={columns} tableData={data} />
    </div>
  );
};

MapLayerDataTable.propTypes = {
  restrictPinsInPolygons: PropTypes.bool,
  counts: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      mapLayerId: PropTypes.string.isRequired,
      subtotal: PropTypes.number.isRequired,
    })
  ).isRequired,
};

MapLayerDataTable.defaultProps = {
  restrictPinsInPolygons: false,
};

export default MapLayerDataTable;
